import { createFileRoute } from "@tanstack/react-router"

import { SurveillancePanel } from "@/pages/SurveillancePanel"

export const Route = createFileRoute("/operations/surveillance")({
  component: SurveillancePanel,
})
